// extracted by mini-css-extract-plugin
export default {"container":"style_container__KeNRx","imageContainer":"style_imageContainer__y80J0","content":"style_content__8dwTV","downloadContainer":"style_downloadContainer__4jSl7"};